/**
 * Card box function component
 */
function CardBox({ children }: { children: JSX.Element }) {

  return (
  <div className="card-box-warp">
    <div className="card-content">
      {children}
    </div>
  </div>
  );
}

// CardBox.defaultProps = {
//   inputLabel: '',
//   valueRequired: false,
// };

export default CardBox;
